<template>
  <vs-popup fullscreen class="rm-order-po-pdf-popup"
            id="rm-order-po-pdf-pop-up"
            :title="`${invoice_data.order_code} INVOICE`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <vx-row class="mb-8">
        <vx-col>
          <div class="flex">
            <div class="flex">
              <vs-button @click="onClickPrint()" color="warning" type="border" >Print</vs-button>
              <vs-button v-if="status_name !== 'Cancelled'" @click.stop="generateReportPromtActive()"  class="ml-2" color="dark" type="border" >
                {{ is_sent_email ? 'Resend Invoice' : 'Send Invoice' }}
              </vs-button>
            </div>
          </div>
        </vx-col>
      </vx-row>

      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="false"
        :filename="'INVOICE_'+invoice_data.invoice_number"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        ref="html2Pdf"
        pdf-content-width="100%"
        :html-to-pdf-options="htmlToPdfOptions"
        @beforeDownload="pdfBeforeDownloaded($event)"
      >
        <section slot="pdf-content"
        style="display: flex; flex-wrap: wrap; padding: 15px;">
          <body id="myelement">
            <div id="full-wrap">


              <main class="clearfix">

                <div id="user" class="clearfix">

                  <div id="user-top">

                    <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0">

                      <tbody>
                      <tr>
                        <td class="head align-left">
                          <img id="logo"
                               src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/ITS-Logo.png"
                               alt="Logo" width="300" height="150" />
                        </td>


                      </tr>


                      <tr>
                        <td>
                          <table id="main-tbl">
                      <thead class="">
                      <tr>
                        <td colspan="2" class="head">
                          <h4 class="m-0" style="color: #000000"><b>SAMPLE INVOICE</b></h4>
                        </td>
                      </tr>
                      </thead>

                      <tbody>

                      <tr>

                        <td class="toptd bd-b-0 bd-r-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">SHIPPER/EXPORTER</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda" width="50%">
                                <div>
                                  <p class="sml">
                                    {{ invoice_data.shipper_address.company_name }}<br>
                                    {{ invoice_data.shipper_address.line_1 }}<br>
                                    {{ invoice_data.shipper_address.line_2 }}<br>
                                    {{ invoice_data.shipper_address.town_state }}<br>
                                    {{ invoice_data.shipper_address.post_code }}<br>
                                    {{ invoice_data.shipper_address.country }}</p>
                                </div>
                              </td>
                              <td class="bodytdb" width="50%">
                                <div>
                                  <p class="sml">Tel. {{ invoice_data.tel || '' }}<br>
                                    Email: {{ invoice_data.email || '' }}<br>
                                    VAT Reg No: {{ invoice_data.vat_reg || '' }}<br>
                                    Company No: {{ invoice_data.company_no || '' }}<br>
                                    EORI for {{ invoice_data.is_eu ? 'NL' : 'NI' }}: {{ invoice_data.is_eu ? invoice_data.eori_nl : invoice_data.eori_ni || '' }}<br>
                                    EORI for EU: {{ invoice_data.eori_eu || '' }}
                                  </p>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="toptd bd-b-0 bd-l-0">
                          <table id="in-tbl">
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">INVOICE DATE:</p>
                                  <p class="sml"><b>{{ invoice_data.invoice_date || '' }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">SAMPLE INVOICE NO:</p>
                                  <p class="sml"><b>{{ invoice_data.invoice_number || '' }}</b></p>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">CUSTOMER P.O. NUMBER:</p>
                                  <p class="sml"><b>{{ invoice_data.customer_order_number || 'N/A' }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">ITS ORDER NUMBER:</p>
                                  <p class="sml"><b>{{ invoice_data.order_code || 'N/A'  }}</b></p>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>

                        <td class="toptd bd-b-0 bd-r-0">
                          <table id="in-tbl" v-if="invoice_data.is_eu">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">IMPORTER OF RECORD</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda" width="50%">
                                <div>
                                  <p class="sml">
                                    {{ invoice_data.shipper_address.company_name }}<br>
                                    {{ invoice_data.shipper_address.line_1 }}<br>
                                    {{ invoice_data.shipper_address.line_2 }}<br>
                                    {{ invoice_data.shipper_address.town_state }}<br>
                                    {{ invoice_data.shipper_address.post_code }}<br>
                                    {{ invoice_data.shipper_address.country }}
                                  </p>
                                </div>
                              </td>
                              <td class="bodytdb" width="50%">
                                <div>
                                  <p class="sml">Tel. {{ invoice_data.tel || '' }}<br>
                                    Email: {{ invoice_data.email || '' }}<br>
                                    <!-- VAT Reg No: {{ invoice_data.vat_reg || '' }}<br> -->
                                    Company No: {{ invoice_data.company_no || '' }}<br>
                                    NL EORI: {{ invoice_data.eori_ni || '' }}<br>
                                    <!-- EORI for EU: {{ invoice_data.eori_eu || '' }} -->
                                  </p>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                          <table id="in-tbl" v-if="!invoice_data.is_eu">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">CONSIGNEE<span v-if="invoice_data.is_eu">/RECEIVER</span></p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda" width="50%">
                                <div>
                                  <p class="sml">
                                    {{ invoice_data.customer_address.company_name }}<br>
                                    {{ invoice_data.customer_address.line_1 }}<br>
                                    {{ invoice_data.customer_address.line_2 }}<br>
                                    {{ invoice_data.customer_address.town_state }}<br>
                                    {{ invoice_data.customer_address.post_code }}<br>
                                    {{ invoice_data.customer_address.country }}
                                  </p>
                                </div>
                              </td>
                              <td class="bodytdb" width="50%">
                                <div>
                                  <p class="sml">
                                    VAT: {{ invoice_data.consignee_vat || 'N/A' }}<br>
                                    EORI: {{ invoice_data.consignee_eori || 'N/A' }}<br>
                                    <span v-if="invoice_data.is_eu">VAT deferred: {{ invoice_data.vat_deferred || 'N/A' }}<br></span>
                                    <span v-if="invoice_data.is_eu">NL EORI: {{ invoice_data.eori_nl || 'N/A' }}<br></span>
                                    TEL: {{ invoice_data.consignee_tel || '' }}<br>
                                    IMPORT LICENCE NO: {{ invoice_data.import_licence_no || 'N/A' }}
                                  </p>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="toptd bd-b-0 bd-l-0">
                          <table id="in-tbl">
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">CUSTOMER ACCOUNT NUMBER:</p>
                                  <p class="sml"><b>{{ invoice_data.customer_account_number || '' }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">TRANSPORT AWB/REF NUMBER:</p>
                                  <p class="sml">
                                    <b v-for="(ref, index_ref) in invoice_data.transport_ref_number" :key="index_ref+'print_ref'">
                                      {{ref}}
                                    </b>
                                  </p>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">INCOTERMS:</p>
                                  <p class="sml"><b>{{ invoice_data.incoterm }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">TERMS OF PAYMENT:</p>
                                  <p class="sml">
                                    <b v-if="invoice_data.is_free_of_charge">Free of charge, no commercial value</b>
                                    <b v-else>{{ invoice_data.payment_terms ? invoice_data.payment_terms.due_date : '' }}</b>
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td class="toptd bd-r-0">
                          <table id="in-tbl" v-if="invoice_data.is_eu">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">CONSIGNEE<span v-if="invoice_data.is_eu">/RECEIVER</span></p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda" width="50%">
                                <div>
                                  <p class="sml">
                                    {{ invoice_data.customer_address.company_name }}<br>
                                    {{ invoice_data.customer_address.line_1 }}<br>
                                    {{ invoice_data.customer_address.line_2 }}<br>
                                    {{ invoice_data.customer_address.town_state }}<br>
                                    {{ invoice_data.customer_address.post_code }}<br>
                                    {{ invoice_data.customer_address.country }}
                                  </p>
                                </div>
                              </td>
                              <td class="bodytdb" width="50%">
                                <div>
                                  <p class="sml">
                                    VAT: {{ invoice_data.consignee_vat || 'N/A' }}<br>
                                    EORI: {{ invoice_data.consignee_eori || 'N/A' }}<br>
                                    <span v-if="invoice_data.is_eu">VAT deferred: {{ invoice_data.vat_deferred || 'N/A' }}<br></span>
                                    <span v-if="invoice_data.is_eu">NL EORI: {{ invoice_data.eori_nl || 'N/A' }}<br></span>
                                    TEL: {{ invoice_data.consignee_tel || '' }}<br>
                                    IMPORT LICENCE NO: {{ invoice_data.import_licence_no || 'N/A' }}
                                  </p>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                          <table id="in-tbl" v-else>
                            <thead>
                              <tr>
                                <td colspan="4" class="headtd">
                                  <div>
                                    <p class="sml">DELIVERY SITE</p>
                                  </div>
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="bodytda">
                                  <div>
                                    <p class="sml">
                                        {{ invoice_data.delivery_address.company_name }}<br>
                                        {{ invoice_data.delivery_address.line_1 }}<br>
                                        {{ invoice_data.delivery_address.line_2 }}<br>
                                        {{ invoice_data.delivery_address.town_state }}<br>
                                        {{ invoice_data.delivery_address.post_code }}<br>
                                        {{ invoice_data.delivery_address.country }}
                                    </p>
                                  </div>
                                </td>
                                <td class="bodytdb">
                                  
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="toptd bd-l-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">FREIGHT DETAILS:</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda">

                                <!-- <div v-if="invoice_data.package_details.length === 1">
                                  <p class="sml">Cube: {{invoice_data.package_details[0].cube}}<br>
                                    Dimensions: {{invoice_data.package_details[0].dimensions}}<br>
                                    Gross Weight: {{invoice_data.package_details[0].gross_weight}}<br>
                                    Net Weight: {{invoice_data.package_details[0].net_weight}}<br>
                                    No. of Boxes/Pallets: {{invoice_data.package_details[0].no_of_pallets}}<br>
                                  </p>
                                </div>
                                <div v-if="invoice_data.package_details.length > 1">
                                  <p class="sml">This invoice contains products that are on different freight bookings</p>
                                </div> -->

                              </td>
                              <td class="bodytdb">
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                      <td class="toptd bd-b-0" colspan="4">
                        <table id="in-tbl" v-if="invoice_data.is_eu">
                          <thead>
                          <tr>
                            <td colspan="4" class="headtd">
                              <div>
                                <p class="sml">DELIVERY SITE</p>
                              </div>
                            </td>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                            <td class="bodytda">
                              <div>
                                <p class="sml">
                                    {{ invoice_data.delivery_address.company_name }}<br>
                                    {{ invoice_data.delivery_address.line_1 }}<br>
                                    {{ invoice_data.delivery_address.line_2 }}<br>
                                    {{ invoice_data.delivery_address.town_state }}<br>
                                    {{ invoice_data.delivery_address.post_code }}<br>
                                    {{ invoice_data.delivery_address.country }}
                                </p>
                              </div>
                            </td>
                            <td class="bodytdb">
                              
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </td>
                      </tr>
                      <tr>

                        <td colspan="2" class="toptd">
                          <table id="content-tbl">
                            <thead>
                            <tr>
                              <th><b>Customer Product Code</b></th>
                              <th><b>Product Code/Name</b></th>
                              <th><b>Quantity(GRAMS)</b></th>
                              <th><b>Commodity Code</b></th>
                              <th><b>Country of Origin</b></th>
                              <th><b>Price Per Unit ({{ invoice_data.account_currency }}/KG)</b></th>
                              <th><b>Net Value ({{ invoice_data.account_currency }})</b></th>
                              <th><b>VAT Rate (%)</b></th>
                              <th><b>VAT Value ({{ invoice_data.account_currency }})</b></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in invoice_data.order_items" :key="index+'print_item'">
                              <td class="break-normal">
                                {{ item.customer_product_code }}
                              </td>

                              <td class="break-normal">
                                {{ item.product_name_code }}
                              </td>
                              <td>{{ Number(item.quantity) }}</td>
                              <td>{{ item.commodity_code }}</td>
                              <td>{{ item.origin }}</td>
                              <td>{{item.price | format_price(order_fx_value) }}</td>
                              <td>{{ calculateItemNetValue(item) }}</td>
                              <td>{{ item.tax_percent }}</td>
                              <td>{{ calculateItemVatValue(item) }}</td>

                            </tr>
                            <tr>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>

                            </tr>

                            <tr>
                              <td colspan="6" rowspan="4"><span v-if="invoice_data.is_eu">Exempt of VAT, article 138 of the VAT Council Directive 2006/112/EC, NL legislation: article 9 sub 2 part 6 Wet OB conjunction Table II position a-6.</span></td>
                              <td colspan="2">Items Total (Incl. VAT in {{invoice_data.account_currency}})</td>
                              <td>{{ itemNetValue() }}</td>
                            </tr>
<!--                            <tr>-->
<!--                              <td>Frieght Cost (20.00%)</td>-->
<!--                              <td>12.00</td>-->
<!--                            </tr>-->
                            <tr v-for="(cost, index_cost) in invoice_data.additional_costs" :key="index_cost+'print_cost'">
                              <td colspan="2">{{ cost.name }} ({{ cost.percent }}% VAT/Tax)</td>
                              <td>{{ calculateCostAmount(cost) }}</td>
                            </tr>
                            <tr>
                              <td colspan="2">Total Order Value <br>(Incl. VAT in {{ invoice_data.account_currency }})</td>
                              <td>{{ totalOrderValue() }}</td>
                            </tr>

                            </tbody>
                          </table>
                        </td>

                      </tr>

                      <tr>
                        <td colspan="2" class="toptd">

                          <table class="no-bd-tbl">
                            <thead>
                            <tr>
                              <td colspan="4">
                                <p v-if="invoice_data.is_eu">
                                  <br>
                                  The exporter of the products covered by this<br>
                                  document with EORI No. GB980555887000 declares that, except where<br>
                                  otherswise clearly indicated, these products
                                  are<br>of the UK preferential origin<br>
                                  <b>Products: Not edible, Not animal origin
                                  </b>
                                </p>
                                <p v-if="!invoice_data.is_eu">
                                  <br>
                                  The exporter of the products covered by this<br>
                                  document with EORI No. XI980555887000 declares that, except where<br>
                                  otherswise clearly indicated, these products
                                  are<br>of the UK preferential origin<br>
                                  <b>Products: Not edible, Not animal origin
                                  </b>
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="2" width="750px">
                                <!-- <p>Payment Details<br>
                                  {{ invoice_data.account_currency }} Electronic Payments:-<br>
                                  Bank: {{ invoice_data.bank_details.name }}<br>
                                  Account Name: {{ invoice_data.bank_details.account_name }}<br>
                                  Account Number: {{ invoice_data.bank_details.account_number }} Sort Code: {{ invoice_data.bank_details.sort_code || 'N/A' }}<br>
                                  IBAN: {{ invoice_data.bank_details.iban || 'N/A' }}<br>
                                  SWIFTBIC: {{ invoice_data.bank_details.swiftbi || 'N/A' }}</p> -->

                              </td>
                              <td>
                                <img v-if="!is_customer_uk" width="200" src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/s_jones_signature.png" alt="">
                              </td>
                              <td>
                                <img v-if="!is_customer_uk" width="200" src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/its_stamp.bmp" alt="">
                              </td>
                            </tr>
                            <tr>
                              <td colspan="4">
                                <p class="align-center">ITS reserves the right to
                                  charge
                                  interest on late payments<br>
                                  ITS terms and conditions of sale apply.</p>
                              </td>
                            </tr>
                            </thead>
                          </table>
                        </td>

                      </tr>


                      </tbody>
                    </table>
                        </td>
                      </tr>









                      </tbody>
                    </table>



                  </div>

                </div>

              </main>



          </div>
          </body>
        </section>
      </vue-html2pdf>



      <body id="myelement">
      <div id="full-wrap">


        <main class="clearfix">

          <div id="user" class="clearfix">

            <div id="user-top">

              <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0">

                <tbody>
                <tr>
                  <td class="head align-left">
                    <img id="logo"
                         src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/ITS-Logo.png"
                         alt="Logo" width="300" height="150" />
                  </td>


                </tr>


                <tr>
                  <td>
                    <table id="main-tbl">
                      <thead class="">
                      <tr>
                        <td colspan="2" class="head">
                          <h4 class="m-0" style="color: #000000"><b>SAMPLE INVOICE</b></h4>
                        </td>
                      </tr>
                      </thead>

                      <tbody>

                      <tr>

                        <td class="toptd bd-b-0 bd-r-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">SHIPPER/EXPORTER</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda" width="50%">
                                <div>
                                  <p class="sml">
                                    {{ invoice_data.shipper_address.company_name }}<br>
                                    {{ invoice_data.shipper_address.line_1 }}<br>
                                    {{ invoice_data.shipper_address.line_2 }}<br>
                                    {{ invoice_data.shipper_address.town_state }}<br>
                                    {{ invoice_data.shipper_address.post_code }}<br>
                                    {{ invoice_data.shipper_address.country }}</p>
                                </div>
                              </td>
                              <td class="bodytdb" width="50%">
                                <div>
                                  <p class="sml">Tel. {{ invoice_data.tel || '' }}<br>
                                    Email: {{ invoice_data.email || '' }}<br>
                                    VAT Reg No: {{ invoice_data.vat_reg || '' }}<br>
                                    Company No: {{ invoice_data.company_no || '' }}<br>
                                    EORI for {{ invoice_data.is_eu ? 'NL' : 'NI' }}: {{ invoice_data.is_eu ? invoice_data.eori_nl : invoice_data.eori_ni || '' }}<br>
                                    EORI for EU: {{ invoice_data.eori_eu || '' }}</p>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="toptd bd-b-0 bd-l-0">
                          <table id="in-tbl">
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">INVOICE DATE:</p>
                                  <p class="sml"><b>{{ invoice_data.invoice_date || '' }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">SAMPLE INVOICE NO:</p>
                                  <p class="sml"><b>{{ invoice_data.invoice_number || '' }}</b></p>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">CUSTOMER P.O. NUMBER:</p>
                                  <p class="sml"><b>{{ invoice_data.customer_order_number || 'N/A' }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">ITS ORDER NUMBER:</p>
                                  <p class="sml"><b>{{ invoice_data.order_code || ''  }}</b></p>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>

                        <td class="toptd bd-b-0 bd-r-0" >
                          <table id="in-tbl" v-if="invoice_data.is_eu">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">IMPORTER OF RECORD</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda" width="50%">
                                <div>
                                  <p class="sml">
                                    {{ invoice_data.shipper_address.company_name }}<br>
                                    {{ invoice_data.shipper_address.line_1 }}<br>
                                    {{ invoice_data.shipper_address.line_2 }}<br>
                                    {{ invoice_data.shipper_address.town_state }}<br>
                                    {{ invoice_data.shipper_address.post_code }}<br>
                                    {{ invoice_data.shipper_address.country }}
                                  </p>
                                </div>
                              </td>
                              <td class="bodytdb" width="50%">
                                <div>
                                  <p class="sml">Tel. {{ invoice_data.tel || '' }}<br>
                                    Email: {{ invoice_data.email || '' }}<br>
                                    <!-- VAT Reg No: {{ invoice_data.vat_reg || '' }}<br> -->
                                    Company No: {{ invoice_data.company_no || '' }}<br>
                                    NL EORI: {{ invoice_data.eori_ni || '' }}<br>
                                    <!-- EORI for EU: {{ invoice_data.eori_eu || '' }} -->
                                  </p>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                          <table id="in-tbl" v-if="!invoice_data.is_eu">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">CONSIGNEE<span v-if="invoice_data.is_eu">/RECEIVER</span></p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda" width="50%">
                                <div>
                                  <p class="sml">
                                    {{ invoice_data.customer_address.company_name }}<br>
                                    {{ invoice_data.customer_address.line_1 }}<br>
                                    {{ invoice_data.customer_address.line_2 }}<br>
                                    {{ invoice_data.customer_address.town_state }}<br>
                                    {{ invoice_data.customer_address.post_code }}<br>
                                    {{ invoice_data.customer_address.country }}
                                  </p>
                                </div>
                              </td>
                              <td class="bodytdb" width="50%">
                                <div>
                                  <p class="sml">
                                    VAT: {{ invoice_data.consignee_vat || 'N/A' }}<br>
                                    EORI: {{ invoice_data.consignee_eori || 'N/A' }}<br>
                                    <span v-if="invoice_data.is_eu">VAT deferred: {{ invoice_data.vat_deferred || 'N/A' }}<br></span>
                                    <span v-if="invoice_data.is_eu">NL EORI: {{ invoice_data.eori_nl || 'N/A' }}<br></span>
                                    TEL: {{ invoice_data.consignee_tel || '' }}<br>
                                    IMPORT LICENCE NO: {{ invoice_data.import_licence_no || 'N/A' }}
                                  </p>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="toptd bd-b-0 bd-l-0">
                          <table id="in-tbl">
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">CUSTOMER ACCOUNT NUMBER:</p>
                                  <p class="sml"><b>{{ invoice_data.customer_account_number || '' }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">TRANSPORT AWB/REF NUMBER:</p>
                                  <p class="sml">
                                    <b v-for="(ref, index_ref) in invoice_data.transport_ref_number" :key="index_ref+'display_ref'">
                                      {{ref}}
                                    </b>
                                  </p>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">INCOTERMS:</p>
                                  <p class="sml"><b>{{ invoice_data.incoterm }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">TERMS OF PAYMENT:</p>
                                  <p class="sml">
                                    <b v-if="invoice_data.is_free_of_charge">Free of charge, no commercial value</b>
                                    <b v-else>{{ invoice_data.payment_terms ? invoice_data.payment_terms.due_date : '' }}</b>
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td class="toptd bd-r-0">
                          <table id="in-tbl" v-if="invoice_data.is_eu">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">CONSIGNEE<span v-if="invoice_data.is_eu">/RECEIVER</span></p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda" width="50%">
                                <div>
                                  <p class="sml">
                                    {{ invoice_data.customer_address.company_name }}<br>
                                    {{ invoice_data.customer_address.line_1 }}<br>
                                    {{ invoice_data.customer_address.line_2 }}<br>
                                    {{ invoice_data.customer_address.town_state }}<br>
                                    {{ invoice_data.customer_address.post_code }}<br>
                                    {{ invoice_data.customer_address.country }}
                                  </p>
                                </div>
                              </td>
                              <td class="bodytdb" width="50%">
                                <div>
                                  <p class="sml">
                                    VAT: {{ invoice_data.consignee_vat || 'N/A' }}<br>
                                    EORI: {{ invoice_data.consignee_eori || 'N/A' }}<br>
                                    <span v-if="invoice_data.is_eu">VAT deferred: {{ invoice_data.vat_deferred || 'N/A' }}<br></span>
                                    <span v-if="invoice_data.is_eu">NL EORI: {{ invoice_data.eori_nl || 'N/A' }}<br></span>
                                    TEL: {{ invoice_data.consignee_tel || '' }}<br>
                                    IMPORT LICENCE NO: {{ invoice_data.import_licence_no || 'N/A' }}
                                  </p>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                          <table id="in-tbl" v-else>
                            <thead>
                              <tr>
                                <td colspan="4" class="headtd">
                                  <div>
                                    <p class="sml">DELIVERY SITE</p>
                                  </div>
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="bodytda">
                                  <div>
                                    <p class="sml">
                                        {{ invoice_data.delivery_address.company_name }}<br>
                                        {{ invoice_data.delivery_address.line_1 }}<br>
                                        {{ invoice_data.delivery_address.line_2 }}<br>
                                        {{ invoice_data.delivery_address.town_state }}<br>
                                        {{ invoice_data.delivery_address.post_code }}<br>
                                        {{ invoice_data.delivery_address.country }}
                                    </p>
                                  </div>
                                </td>
                                <td class="bodytdb">
                                  
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="toptd bd-l-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">FREIGHT DETAILS:</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda">

                                <!-- <div v-if="invoice_data.package_details.length === 1">
                                  <p class="sml">Cube: {{invoice_data.package_details[0].cube}}<br>
                                    Dimensions: {{invoice_data.package_details[0].dimensions}}<br>
                                    Gross Weight: {{invoice_data.package_details[0].gross_weight}}<br>
                                    Net Weight: {{invoice_data.package_details[0].net_weight}}<br>
                                    No. of Boxes/Pallets: {{invoice_data.package_details[0].no_of_pallets}}<br>
                                  </p>
                                </div>
                                <div v-if="invoice_data.package_details.length > 1">
                                  <p class="sml">This invoice contains products that are on different freight bookings</p>
                                </div> -->

                              </td>
                              <td class="bodytdb">
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                      <td class="toptd bd-b-0" colspan="4">
                        <table id="in-tbl" v-if="invoice_data.is_eu">
                          <thead>
                          <tr>
                            <td colspan="4" class="headtd">
                              <div>
                                <p class="sml">DELIVERY SITE</p>
                              </div>
                            </td>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                            <td class="bodytda">
                              <div>
                                <p class="sml">
                                    {{ invoice_data.delivery_address.company_name }}<br>
                                    {{ invoice_data.delivery_address.line_1 }}<br>
                                    {{ invoice_data.delivery_address.line_2 }}<br>
                                    {{ invoice_data.delivery_address.town_state }}<br>
                                    {{ invoice_data.delivery_address.post_code }}<br>
                                    {{ invoice_data.delivery_address.country }}
                                </p>
                              </div>
                            </td>
                            <td class="bodytdb">
                              
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </td>
                      </tr>
                      <tr>

                        <td colspan="2" class="toptd">
                          <table id="content-tbl">
                            <thead>
                            <tr>
                              <th><b>Customer Product Code</b></th>
                              <th><b>Product Code/Name</b></th>
                              <th><b>Quantity(GRAMS)</b></th>
                              <th><b>Commodity Code</b></th>
                              <th><b>Country of Origin</b></th>
                              <th><b>Price Per Unit ({{ invoice_data.account_currency }}/KG)</b></th>
                              <th><b>Net Value ({{ invoice_data.account_currency }})</b></th>
                              <th><b>VAT Rate (%)</b></th>
                              <th><b>VAT Value ({{ invoice_data.account_currency }})</b></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in invoice_data.order_items" :key="index+'display_item'">
                              <td class="break-normal">
                                {{ item.customer_product_code }}
                              </td>

                              <td class="break-normal">
                                {{ item.product_name_code }}
                              </td>
                              <td>{{ Number(item.quantity) }}</td>
                              <td>{{ item.commodity_code }}</td>
                              <td>{{ item.origin }}</td>
                              <td>{{item.price | format_price(order_fx_value) }}</td>
                              <td>{{ calculateItemNetValue(item) }}</td>
                              <td>{{ item.tax_percent  }}</td>
                              <td>{{ calculateItemVatValue(item) }}</td>

                            </tr>
                            <tr>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>

                            </tr>

                            <tr>
                              <td colspan="6" rowspan="4"><span v-if="invoice_data.is_eu">Exempt of VAT, article 138 of the VAT Council Directive 2006/112/EC, NL legislation: article 9 sub 2 part 6 Wet OB conjunction Table II position a-6.</span></td>
                              <td colspan="2">Items Total (Incl. VAT in {{invoice_data.account_currency}})</td>
                              <td>{{ itemNetValue() }}</td>
                            </tr>
<!--                            <tr>-->
<!--                              <td>Frieght Cost (20.00%)</td>-->
<!--                              <td>12.00</td>-->
<!--                            </tr>-->
                            <tr v-for="(cost, index_cost) in invoice_data.additional_costs" :key="index_cost+'display_cost'">
                              <td colspan="2">{{ cost.name }} ({{ cost.percent }}% VAT/Tax)</td>
                              <td>{{ calculateCostAmount(cost) }}</td>
                            </tr>
                            <tr>
                              <td colspan="2">Total Order Value <br>(Incl. VAT in {{ invoice_data.account_currency }})</td>
                              <td>{{ totalOrderValue() }}</td>
                            </tr>

                            </tbody>
                          </table>
                        </td>

                      </tr>

                      <tr>
                        <td colspan="2" class="toptd">

                          <table class="no-bd-tbl">
                            <thead>
                            <tr>
                              <td colspan="4">
                                <p v-if="invoice_data.is_eu">
                                  <br>
                                  The exporter of the products covered by this<br>
                                  document with EORI No. GB980555887000 declares that, except where<br>
                                  otherswise clearly indicated, these products
                                  are<br>of the UK preferential origin<br>
                                  <b>Products: Not edible, Not animal origin
                                  </b>
                                </p>
                                <p v-if="!invoice_data.is_eu">
                                  <br>
                                  The exporter of the products covered by this<br>
                                  document with EORI No. XI980555887000 declares that, except where<br>
                                  otherswise clearly indicated, these products
                                  are<br>of the UK preferential origin<br>
                                  <b>Products: Not edible, Not animal origin
                                  </b>
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="2" width="750px">
                                <!-- <p>Payment Details<br>
                                  {{ invoice_data.account_currency }} Electronic Payments:-<br>
                                  Bank: {{ invoice_data.bank_details.name }}<br>
                                  Account Name: {{ invoice_data.bank_details.account_name }}<br>
                                  Account Number: {{ invoice_data.bank_details.account_number }} Sort Code: {{ invoice_data.bank_details.sort_code || 'N/A' }}<br>
                                  IBAN: {{ invoice_data.bank_details.iban || 'N/A' }}<br>
                                  SWIFTBIC: {{ invoice_data.bank_details.swiftbi || 'N/A' }}</p> -->

                              </td>
                              <td>
                                <img v-if="!is_customer_uk" width="200" src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/s_jones_signature.png" alt="">
                              </td>
                              <td>
                                <img v-if="!is_customer_uk" width="200" src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/its_stamp.bmp" alt="">
                              </td>
                            </tr>
                            <tr>
                              <td colspan="4">
                                <p class="align-center">ITS reserves the right to
                                  charge
                                  interest on late payments<br>
                                  ITS terms and conditions of sale apply.</p>
                              </td>
                            </tr>
                            </thead>
                          </table>
                        </td>

                      </tr>


                      </tbody>
                    </table>
                  </td>
                </tr>









                </tbody>
              </table>



            </div>

          </div>

        </main>



      </div>
      </body>
    </vx-card>

    <vs-prompt
      @cancel="customer_email=''"
      @accept="sendInvoice"
      @close="activePrompt = false"
      :title="'Select customer user email to send'"
      :accept-text="'Confirm'"
      :color="'primary'"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <span>Select user email</span>
        <v-select
          :clearable="true" name="customerId" placeholder=""
          v-model="customer_email"
          label="email"
          :options="customer_list"
          :reduce="option => option.email"
          :dir="$vs.rtl ? 'rtl' : 'ltr'">
          <template v-slot:option="option">
              <span>{{option.email}} ( {{option.job_title || 'N/A'}} ) </span>
          </template>
          </v-select>
      </div>
    </vs-prompt>

  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import Calculations from '@/mixins/Calculations'
  const CustomerRepository = RepositoryFactory.get('customer')
  const FileRepository = RepositoryFactory.get('file');
  const DropDownRepository = RepositoryFactory.get('drop_down')

  import { Printd } from 'printd'
  import VueHtml2pdf from 'vue-html2pdf'

  import {mapActions, mapGetters} from "vuex";

  function initialState() {
    return {
      open: false,
      activePrompt: false,
      customer_list: [],
      customer_email: '',
      id: '',
      data: {},
      order_code: '',
      status_name: '',
      is_proforma_account: false,
      is_sent_email: false,
      invoice_data: {
        account_currency: '',
        order_items: [],
        additional_costs: [],
        package_details: [],
        tel: '',
        bank_details: {
          name: '',
          account_name: '',
          account_number: '',
          iban: '',
          sort_code: '',
          swiftbi: ''
        },
        shipper_address: {
          company_name: '',
          line_1: '',
          line_2: '',
          line_3: '',
          town_state: '',
          post_code: '',
          country: '',
        },
        customer_address: {
          company_name: '',
          line_1: '',
          line_2: '',
          line_3: '',
          town_state: '',
          post_code: '',
          country: '',
        },
        delivery_address: {
          company_name: '',
          line_1: '',
          line_2: '',
          line_3: '',
          town_state: '',
          post_code: '',
          country: '',
        },
        is_eu: false,
        fx_value: '1.00'
      },
      htmlToPdfOptions: {
        margin: 0,
        image: {
          type: 'jpeg',
          quality: 0.98
        },
        enableLinks: false,
        html2canvas: {
          scale: 2,
          useCORS: true
        },
        jsPDF: {
          unit: 'in',
          format: 'a4',
          orientation: 'portrait'
        }
      },
    }
  }

  export default {
    name: 'SampleOrderInvoicePdfPopUp',
    data () {
      return initialState()
    },
    computed: {
      ...mapGetters(["allSettings"]),
      styleObject: function () {
        const total_item_height = this.invoice_data.order_items.length * 55
        const total_add_cost_line_height =  this.invoice_data.additional_costs.length * 100
        const space_height = 450 - (total_item_height + total_add_cost_line_height)
        return {
          height: `${space_height}px`
        }
      },
      is_customer_uk: function () {
        return ['Great Britain', 'Northern Ireland', 'United Kingdom'].includes(this.invoice_data.customer_address.country);
      },
      is_customer_ni: function () {
        return ['Northern Ireland', 'Antrim', 'Armagh', 'Down', 'Fermanagh', 'Londonderry', 'Tyrone'].includes(this.invoice_data.delivery_address.country);
      },
      is_customer_eu: function () {
        return ['Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Republic of Cyprus', 'Czech Republic', 'Denmark', 'Estonia', 'Finland',
          'France', 'Germany', 'Greece', 'Hungary', 'Ireland', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'Netherlands',
          'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden'].includes(this.invoice_data.delivery_address.country);
      },
      order_fx_value(){
        return Number(this.invoice_data.fx_value).toFixed(2)
      }
    },
    methods:{
      ...mapActions(["fetchSettings"]),
      async openPopup (id, order_code, status_name, is_proforma_account, secret_code, is_sent_email = false) {
        try {
          await Object.assign(this.$data, initialState())
          this.id = id
          this.secret_code = secret_code
          this.order_code = order_code
          this.status_name = status_name
          this.is_proforma_account = is_proforma_account
          this.is_sent_email = is_sent_email
          this.open = true
          await this.getInvoiceDetails()
          // await this.fetchSettings()
        } catch (error) {

        }
      },
      calculateItemNetValue(item) {
        const unitPrice = Number(this.$options.filters.format_price(item.price, this.order_fx_value))
        const qtyInKg = Number(item.quantity) / 1000
        return (qtyInKg * unitPrice).toFixed(2)
      },
      calculateItemVatValue(item) {
        const net = Number(this.calculateItemNetValue(item))
        const taxRate = Number(item.tax_percent || 0) / 100
        return (net * taxRate).toFixed(2)
      },
      calculateCostAmount(cost) {
        return Number(this.$options.filters.format_price(cost.amount, this.order_fx_value)).toFixed(2)
      },
      itemNetValue() {
        const total = (this.invoice_data.order_items || []).reduce((a, b) => {
          const net = Number(this.calculateItemNetValue(b))
          const vat = Number(this.calculateItemVatValue(b))
          return a + net + vat
        }, 0)
        return Number(total).toFixed(2)
      },
      totalOrderValue() {
        const total_add_cost = (this.invoice_data.additional_costs || []).reduce((a, b) => {
          const amt = Number(this.calculateCostAmount(b))
          const vatRate = Number(b.percent || b.vat_percent || 0) / 100
          return a + (amt * (1 + vatRate))
        }, 0)
        const total = Number(this.itemNetValue())
        return Number(total_add_cost + total).toFixed(2)
      },
      async testPrint() {
        const d = new Printd()
        d.printURL('/pages/product-orders/167', ({ launchPrint }) => {

          // fire printing!
          launchPrint()
        })
      },
      async getInvoiceDetails() {
        await this.$vs.loading({
          container: '#rm-order-po-pdf-pop-up',
          scale: 0.45
        })
        try {
          const {data} = (await CustomerRepository.getSampleOrderInvoiceData(this.secret_code)).data
          data.order_items.forEach(item => {
            item.price = Number(item.price)
          })
          this.invoice_data =  data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#rm-order-po-pdf-pop-up > .con-vs-loading')
      },
      onClickPrint() {
         const d = new Printd()
        const styles = `
          html,
body {
  -webkit-print-color-adjust: exact !important;
}
@media print {
  body {
    zoom: 75%;
  }
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

a {
  color: #0087C3;
  text-decoration: none;
}

body {
  position: relative;
  margin: 0 auto;
  color: #000000;
  background: #FFFFFF;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
}

div#full-wrap {
  width: 40cm;
  max-width: 100%;
  margin: 0 auto;
}

h4 {
  font-size: 24px;
}

p {
  font-size: 16px;
  margin: 0;
}

.sml {
  font-size: 14px;
}

main {
  padding: 0px 10px 20px 10px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 20px;
  font-size: 13px;

}

table th,
table td {
  padding: 20px;
  text-align: center;
  vertical-align: top;
}

table td:nth-child(2) {
  word-break: break-all;
}

table th {
  white-space: nowrap;
  font-weight: normal;
  color: #000;
}

table td {
  text-align: left;
}

table.txt-center td {
  text-align: center;
}

table.txt-left td {
  text-align: left;
}

table.txt-right td {
  text-align: right;
}


div#user-top {
  width: 100%;
  margin: 2em auto 2em auto;
}

div#user-top table {
  margin: 0 auto 0 auto;
  text-align: center;
  width: 100%;
}

div#user-top table td {
  padding: 5px 20px;
  font-size: 14px;
}

div#user-top .head {
  vertical-align: middle;
  text-align: center;

}

table#in-tbl {
  width: 100%;

}

table#in-tbl td {
  border: 2px solid #000;

}

table#in-tbl thead td.headtd {
  border: 2px solid #000;
  border-bottom-width: 0px;

}

table#in-tbl tbody td.bodytda {
  border: 2px solid #000;
  border-top-width: 0px;
  border-right-width: 0px;

}

table#in-tbl tbody td.bodytdb {
  border: 2px solid #000;
  border-top-width: 0px;
  border-left-width: 0px;

}

table#in-tbl tbody td.bodytd {
  border: 2px solid #000;
  border-top-width: 0px;


}

table#main-tbl thead td {
  border: 3px solid #000;
  border-bottom-width: 2px;

}

table#main-tbl tbody td.toptd {
  border: 3px solid #000;
  border-top-width: 0px;
  padding: 5px;
  width: 50%;
}

table#main-tbl tbody td.toptd table#in-tbl {
  min-height: 15em;
}

table#content-tbl th,
table#content-tbl td {
  border: 2px solid #000;
  font-size: 13px !important;
  text-align: center;
}


/* table#content-tbl td[rowspan="1"] {
    height: 300px;
} */


table#content-tbl td.htd {
  height: 350px;
}

td.no-bd {
  border-left: 0px !important;
  border-bottom: 0px !important;
}

table.no-bd-tbl td {
  border: 0px !important;

}

table.no-bd-tbl {
  margin-bottom: 0 !important;
}

.align-left {
  text-align: left !important;
}

.align-center {
  text-align: center !important;
}

.align-right {
  text-align: right !important;
}

footer {
  padding: 0 30px;
}

.p-0 {
  padding: 0 !important;
}

.m-0 {
  margin: 0 !important;
}

.bd-b-0 {
  border-bottom-width: 0px !important;
}

.bd-r-0 {
  border-right-width: 0px !important;
}

.bd-l-0 {
  border-left-width: 0px !important;
}
        `
        d.print(document.getElementById('myelement'), [styles])
      },
      async generateReportPromtActive() {
        try {
          if (this.invoice_data && this.invoice_data.customer_id) {
            const { data } = (await DropDownRepository.getCustomerUsersDropdownList(this.invoice_data.customer_id)).data
            this.customer_list = data
          } else if (this.invoice_data && this.invoice_data.customer_lead && this.invoice_data.customer_lead.email) {
            this.customer_list = [
              {
                email: this.invoice_data.customer_lead.email,
                job_title: this.invoice_data.customer_lead.job_title || this.invoice_data.customer_lead.company_name || 'Lead'
              }
            ]
          }
        } catch (e) {

        }
        this.open = false
        this.activePrompt = true
      },
      async sendInvoice() {
        this.open = true
        this.activePrompt = false
        this.$vs.loading()
        try {
          if(this.is_sent_email) {
            await CustomerRepository.reSendSampleOrderInvoice(this.id, { user_email: this.customer_email})
          } else {
            await CustomerRepository.sendSampleOrderInvoice(this.id, { user_email: this.customer_email})
          }
          this.open = false
          this.$parent.refreshData()
          this.showSuccessMessage('Invoice sent successfully')
        } catch (e) {
          this.convertAndNotifyError(e)
        }

        this.$vs.loading.close()
      },
      async pdfBeforeDownloaded({html2pdf, options, pdfContent}) {
        this.$vs.loading()
        const vm = this
        await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then(async (pdf) => {
          const payload = { file: btoa(pdf.output()), file_name: vm.invoice_data.invoice_number, path: 'order/invoice' }
          const file_name = (await FileRepository.uploadBase64File(payload)).data.data.file
          try {
            await CustomerRepository.invoiceSentCustomer(vm.id, { user_email: vm.customer_email, attachment: file_name })
            vm.showSuccessMessage('Invoice sent successfully')
          } catch (e) {
            vm.convertAndNotifyError(e)
          }
        })
        vm.$parent.refreshData()
        vm.$vs.loading.close()
      },
    },
    components: {
      'v-select': vSelect,
      VueHtml2pdf
    },
    mixins: [SuccessMessage, ErrorMessages, Calculations],
  }
</script>

<style scoped>
html,
body {
  -webkit-print-color-adjust: exact !important;
}
/*@media print {*/
/*  body {*/
/*    zoom: 50%;*/
/*  }*/
/*}*/

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

a {
  color: #0087C3;
  text-decoration: none;
}

body {
  position: relative;
  margin: 0 auto;
  color: #000000;
  background: #FFFFFF;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
}

div#full-wrap {
  width: 40cm;
  max-width: 100%;
  margin: 0 auto;
}

h4 {
  font-size: 24px;
}

p {
  font-size: 16px;
  margin: 0;
}

.sml {
  font-size: 14px;
}

main {
  padding: 0px 10px 20px 10px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 20px;
  font-size: 13px;

}

table th,
table td {
  padding: 20px;
  text-align: center;
  vertical-align: top;
}

table td:nth-child(2) {
  word-break: break-all;
}

table th {
  white-space: nowrap;
  font-weight: normal;
  color: #000;
}

table td {
  text-align: left;
}

table.txt-center td {
  text-align: center;
}

table.txt-left td {
  text-align: left;
}

table.txt-right td {
  text-align: right;
}


div#user-top {
  width: 100%;
  margin: 2em auto 2em auto;
}

div#user-top table {
  margin: 0 auto 0 auto;
  text-align: center;
  width: 100%;
}

div#user-top table td {
  padding: 5px 20px;
  font-size: 14px;
}

div#user-top .head {
  vertical-align: middle;
  text-align: center;

}

table#in-tbl {
  width: 100%;

}

table#in-tbl td {
  border: 2px solid #000;

}

table#in-tbl thead td.headtd {
  border: 2px solid #000;
  border-bottom-width: 0px;

}

table#in-tbl tbody td.bodytda {
  border: 2px solid #000;
  border-top-width: 0px;
  border-right-width: 0px;

}

table#in-tbl tbody td.bodytdb {
  border: 2px solid #000;
  border-top-width: 0px;
  border-left-width: 0px;

}

table#in-tbl tbody td.bodytd {
  border: 2px solid #000;
  border-top-width: 0px;


}

table#main-tbl thead td {
  border: 3px solid #000;
  border-bottom-width: 2px;

}

table#main-tbl tbody td.toptd {
  border: 3px solid #000;
  border-top-width: 0px;
  padding: 5px;
  width: 50%;
}

table#main-tbl tbody td.toptd table#in-tbl {
  min-height: 15em;
}

table#content-tbl th,
table#content-tbl td {
  border: 2px solid #000;
  font-size: 13px !important;
  text-align: center;
}


/* table#content-tbl td[rowspan="1"] {
    height: 300px;
} */


table#content-tbl td.htd {
  height: 300px;
}

td.no-bd {
  border-left: 0px !important;
  border-bottom: 0px !important;
}

table.no-bd-tbl td {
  border: 0px !important;

}

table.no-bd-tbl {
  margin-bottom: 0 !important;
}

.align-left {
  text-align: left !important;
}

.align-center {
  text-align: center !important;
}

.align-right {
  text-align: right !important;
}

footer {
  padding: 0 30px;
}

.p-0 {
  padding: 0 !important;
}

.m-0 {
  margin: 0 !important;
}

.bd-b-0 {
  border-bottom-width: 0px !important;
}

.bd-r-0 {
  border-right-width: 0px !important;
}

.bd-l-0 {
  border-left-width: 0px !important;
}
</style>
